import styled, { useTheme } from 'styled-components'
import { Flex, Text, Locked, CheckmarkIcon, TimerIcon } from 'vvs-uikit'

type NoticeType = 'success' | 'locked' | 'coming-soon'

export const QuestDetailNotice = ({ type, children }: { type: NoticeType; children: React.ReactNode }) => {
  return (
    <NoticeFlex type={type}>
      <IconComponent type={type} />
      <Text color={textColor(type)} lineHeight="20px" fontWeight="700">
        {children}
      </Text>
    </NoticeFlex>
  )
}

const IconComponent = ({ type }: { type: NoticeType }) => {
  const theme = useTheme()

  if (type === 'success') return <CheckmarkIcon width="22px" height="20px" fill={theme.colors.black} />
  if (type === 'locked') return <Locked width="22px" height="20px" />
  if (type === 'coming-soon') return <TimerIcon width="22px" height="20px" fill={theme.colors.lightBeige} />

  return null
}

const textColor = (type: NoticeType) => {
  if (type === 'success') return 'black'
  if (type === 'locked' || type === 'coming-soon') return 'lightBeige'

  return 'black'
}

const NoticeFlex = styled(Flex)<{ type: NoticeType }>`
  align-items: center;
  padding: 16px;
  gap: 16px;
  background-color: ${({ theme, type }) => {
    if (type === 'success') return theme.colors.gotchiSuccessGreen

    return theme.colors.black
  }};
`
